const KeyPager = ({
    startKey = '',
    endKey = '',
    hasMore = false,
} = {}) => ({
    startKey: String(startKey),
    endKey: String(endKey),
    hasMore: Boolean(hasMore),
});

export default KeyPager;
